$(document).ready(function(){
    $('#valor_objetivo').priceFormat({
        prefix: 'R$ ',
        centsSeparator: ',',
        thousandsSeparator: '.'
    });
});

